import { createTheme } from '@mui/material/styles';
import { light } from './light';
// Dark theme is copy of light theme with some minor changes
export const dark = createTheme({
    palette: {
        mode: 'dark',
        text: Object.assign(Object.assign({}, light.palette.text), { primary: '#E0E0E0', secondary: '#B0B0B0' }),
        actions: Object.assign(Object.assign({}, light.palette.actions), { main: '#E0E0E0' }),
        background: {
            default: '#000000',
            secondary: '#212121'
        },
        primary: Object.assign(Object.assign({}, light.palette.primary), { main: '#8980EF', background: '#2b2942' }),
        secondary: Object.assign({}, light.palette.secondary),
        success: Object.assign({}, light.palette.success),
        info: Object.assign({}, light.palette.info),
        warning: Object.assign({}, light.palette.warning),
        error: Object.assign({}, light.palette.error),
        other: Object.assign({}, light.palette.other)
    }
});
